import React from 'react'

const AbousUs = () => {
  
  return (
    <div >
      <img className='d-flex justify-content-center' src= "../lazar.png" />
      <section className="about-us">

      <p className="section-description">
        At our sportswear store, we are passionate about providing high-quality athletic clothing and gear for every type of athlete. Our mission is to help our customers perform at their best by offering the best possible products and service. We believe that everyone deserves to feel confident and comfortable in their sportswear, and we strive to meet the diverse needs of athletes of all levels. From running shoes and workout clothes to sports accessories and equipment, we are committed to supporting our customers on their fitness journey. Thank you for choosing us as your go-to sportswear store!
      </p>
    </section>
    </div>
  )
}

export default AbousUs